import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  timelineItemClasses,
  TimelineSeparator,
} from "@mui/lab";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const FullDetailsRegularization = ({
  data,
  getStatusData,
  getEmployeeName,
}) => {
  const entries = data?.entries;
  const noOfDays = data?.entries.length;

  const { employeesList } = useSelector((state) => state.notification);
  const columns = [
    { field: "id", headerName: "S no.", width: 80, sortable: false },
    { field: "date", headerName: "Date", width: 200, sortable: false },
    {
      field: "approveReject",
      headerName: "Approve/Reject",
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <p className={`${getStatusData(params.row.approveReject).style}`}>
          {params.row.approveReject}
        </p>
      ),
    },
    {
      field: "adminRemarks",
      headerName: "Admin Remarks",
      width: 200,
      sortable: false,
    },
    { field: "inTime", headerName: "In Time", width: 100, sortable: false },
    { field: "outTime", headerName: "Out Time", width: 150, sortable: false },
    { field: "remarks", headerName: "Remarks", flex: 1, sortable: false },
  ];
  const rowData = entries.map((row, index) => ({
    id: index + 1,
    date: row.date,
    approveReject: data.status,
    adminRemarks: data.rejectionReason || "-",
    inTime: row.inTime.hour + ":" + row.inTime.minute,
    outTime: row.outTime.hour + ":" + row.outTime.minute,
    remarks: row.reason || "-",
  }));
  const getCcNames = () => {
    let cCNames = "";
    data.ccList.map((each) => {
      const name = employeesList.find((item) => item.id === each);
      cCNames = cCNames + name.name + ", ";
    });
    return cCNames.trim(",");
  };
  const getApproverOrRejectedName = (prop) => {
    const name = employeesList.find((each) => each?.id === data[prop]);
    return name?.name || "-";
  };

  const timeLineContent = () => {
    switch (data.status) {
      case "PENDING":
        return (
          <>
            <p className="text-black font-bold">
              {getStatusData().displayMessage}
            </p>
          </>
        );
      case "APPROVED":
        return (
          <>
            <p className="text-black"> Approved by</p>
            <p className="text-black font-bold">
              {getApproverOrRejectedName("approvedBy")}
            </p>
            <p className="text-xs">
              {dayjs(data.approvedDate).format("DD MMM YYYY h:mm A")}
            </p>
          </>
        );
      case "REJECTED":
        return (
          <>
            {" "}
            <p className="text-black"> Rejected by</p>
            <p className="text-black font-bold">
              {getApproverOrRejectedName("rejectedBy")}
            </p>
            <p className="text-sm">
              {dayjs(data?.declinedDate).format("DD MMM YYYY h:mm A")}
            </p>
          </>
        );
      case "CANCELLED":
        return (
          <>
            <p className="text-black"> Cancelled By </p>
            <p className="text-black font-bold">
              {data?.employeeName || "employeeName"}
            </p>
          </>
        );
      default:
        return "";
    }
  };
  return (
    <div className="flex gap-5">
      <div className="w-[75%] flex gap-3 flex-col">
        <div className="border border-gray-300 p-5">
          <div className="flex justify-between font-medium">
            <p>{getStatusData().displayMessage}</p>
            <p className={`${getStatusData().style}`}>{data?.status}</p>
          </div>
          <div className="bg-blue-100 flex justify-between m-3 p-3  border border-gray-300 rounded-md font-normal shadow-md">
            <p>Remarks: {data?.remarks || "-"}</p>
            <p className="border-l-2 border-[#36454F] pl-5">
              No.of days {noOfDays}
            </p>
          </div>
          {data.ccList.length !== 0 && (
            <div className=" flex justify-start gap-3 p-3">
              <div>
                <p className="font-bold">Details</p>
                <p className="font-semibold text-gray-400">CC to:</p>
              </div>
              <p className="self-end">{getCcNames()}</p>
            </div>
          )}
        </div>

        <div className="border border-gray-300 rounded-2xl p-2 bg-white h-auto">
          <p className="m-3 font-medium">Date applied for regularization.</p>
          <DataGrid
            rows={rowData}
            columns={columns}
            hideFooterPagination
            rowHeight={50}
            disableColumnMenu
            disableColumnFilter
            hideFooter
            rowSelection={false}
            autoHeight={true}
            sx={{
              fontSize: 14,
              fontFamily: "sans-serif",
              "& .MuiDataGrid-columnHeaderTitle": {
                overflow: "scroll",
                lineHeight: "1.43rem",
                whiteSpace: "normal",
                fontSize: "0.875rem",
              },
            }}
            columnHeaderHeight={60}
          />
        </div>
      </div>

      <div className="w-[25%] h-fit">
        <div className="border mt-1 border-gray-300 rounded-2xl bg-white w-[100%] h-full mr-4">
          <Timeline
            sx={{
              [`& .${timelineItemClasses.root}:before`]: {
                flex: 0,
                padding: 0,
              },
            }}
            className="my-6"
          >
            <p>Application TimeLine</p>
            <TimelineItem>
              <TimelineSeparator className="h-44">
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>{timeLineContent()}</TimelineContent>
            </TimelineItem>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot />
              </TimelineSeparator>
              <TimelineContent>
                <p>Applied On</p>
                <p>
                  {dayjs(data.createdDate).format("DD MMM,YYYY")} by{" "}
                  {getEmployeeName("appliedBy")}
                </p>
              </TimelineContent>
            </TimelineItem>
          </Timeline>
        </div>
      </div>
    </div>
  );
};

export default FullDetailsRegularization;
